import React from 'react'
import { CreateTripDraft, clearStartDate, setStartDate } from './core/draft'
import { stepTitle } from './core/presentation'
import CreateTripCalendar from './CreateTripCalendar'
import { Heading } from './shared.styles'
import { ClearButton, HeadingRow, StepColumn } from './WhenStep.styles'

interface WhenStepProps {
	draft: CreateTripDraft
	onChange: (draft: CreateTripDraft) => void
	/** Trailing trip days no destination owns — only the edit flow has them. */
	uncoveredDays?: number
}

/**
 * Step 2 — one start date, no range: the length is already known from the
 * places. Picking a day lays every destination's range onto the calendar; the
 * bottom bar spells the resulting dates out.
 */
const WhenStep: React.FC<WhenStepProps> = ({ draft, onChange, uncoveredDays = 0 }) => (
	<StepColumn>
		<HeadingRow>
			<Heading as="h2">{stepTitle('when')}</Heading>
			<ClearButton
				type="button"
				disabled={!draft.startDate}
				aria-hidden={!draft.startDate}
				onClick={() => onChange(clearStartDate(draft))}
			>
				Clear
			</ClearButton>
		</HeadingRow>
		<CreateTripCalendar
			draft={draft}
			uncoveredDays={uncoveredDays}
			onPickDate={date => onChange(setStartDate(draft, date))}
		/>
	</StepColumn>
)

export default WhenStep
